module.exports = __webpack_public_path__ + "06_face.bf458ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer1/06_face.png
// module id = WkVH
// module chunks = 0